import {Button, ButtonProps, useMediaQuery} from "@chakra-ui/react";
import React, { useMemo } from "react";

const APButton = ({ children, sx, ...others }: ButtonProps) => {
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");
  const buttonStyle = useMemo(() => {
    if (others.colorScheme === "primary") {
      return {
        mainBg: "primary",
        hoverBg: "#B9E2E7",
        boxShadow: "0px 6px 0px #D0D23F",
        hoverBoxShadow: "0px 6px 0px #ADD6DB",
        border: "unset",
        color: "#000",
      };
    } else if (others.colorScheme === "error") {
      return {
        mainBg: "#f95928",
        hoverBg: "#fc7928",
        boxShadow: "0px 4px 0 0 #d13100",
        border: "1px solid #f95928",
        color: "#fff",
      };
    } else {
      return {
        mainBg: "white",
        hoverBg: "primary",
        boxShadow: "0px 6px 0px #E7E1D8",
        border: "1px solid #E7E1D8",
        color: "#000",
      };
    }
  }, [others.colorScheme]);

  return (
    <Button
      {...others}
      sx={{
        bg: buttonStyle.mainBg,
        color: buttonStyle.color,
        boxShadow: buttonStyle.boxShadow,
        border: buttonStyle.border,
        h: isLargeScreen ? "70px" : "48px",
        fontSize: isLargeScreen ? "23px" : "inherit",
        "&:hover": {
          bg: buttonStyle.hoverBg,
          boxShadow: buttonStyle.hoverBoxShadow,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default APButton;
